(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5943],{

/***/ 98324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;


/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ArrowIcon_ArrowIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/icons/ArrowIcon/ArrowIcon.tsx



var ArrowIcon = function(param) {
    var _fontsize = param.fontsize, fontsize = _fontsize === void 0 ? "3rem" : _fontsize, _className = param.className, className = _className === void 0 ? "" : _className, _wobble = param.wobble, wobble = _wobble === void 0 ? true : _wobble;
    var fontSizeNumber = fontsize.replace(/\D+$/g, "");
    var fontSizeUnit = fontsize.replace(fontSizeNumber, "");
    var marginFix = "-".concat(Number(fontSizeNumber) * 0.055).concat(fontSizeUnit);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: style_default().dynamic([
                    [
                        "d5af9c333725bae1",
                        [
                            fontsize,
                            marginFix
                        ]
                    ]
                ]) + " " + "wrap an-wobble-horizontal ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: style_default().dynamic([
                        [
                            "d5af9c333725bae1",
                            [
                                fontsize,
                                marginFix
                            ]
                        ]
                    ]) + " " + "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: style_default().dynamic([
                                [
                                    "d5af9c333725bae1",
                                    [
                                        fontsize,
                                        marginFix
                                    ]
                                ]
                            ]) + " " + "si-hyphen"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: style_default().dynamic([
                                [
                                    "d5af9c333725bae1",
                                    [
                                        fontsize,
                                        marginFix
                                    ]
                                ]
                            ]) + " " + "si-greater"
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "d5af9c333725bae1",
                dynamic: [
                    fontsize,
                    marginFix
                ],
                children: ".wrap.__jsx-style-dynamic-selector{}i.__jsx-style-dynamic-selector::before{width:.27em;font-size:".concat(fontsize, "}.si-hyphen.__jsx-style-dynamic-selector{margin-right:").concat(marginFix, "}")
            })
        ]
    });
};
/* harmony default export */ var ArrowIcon_ArrowIcon = (ArrowIcon);

;// CONCATENATED MODULE: ./src/components/elements/icons/ArrowIcon/index.ts



/***/ }),

/***/ 2273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BestsellerSliderBlock_BestsellerSliderBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/bestsellers/actions.ts + 1 modules
var actions = __webpack_require__(24206);
// EXTERNAL MODULE: ./src/features/bestsellers/reducer.ts
var reducer = __webpack_require__(47834);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/features/bestsellers/selectors.ts

var selectBestsellers = function(state) {
    return state.bestsellers;
};
var bestsellersSelector = (0,es/* createSelector */.P1)(selectBestsellers, function(state) {
    return state;
});

;// CONCATENATED MODULE: ./src/features/bestsellers/index.ts




// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/BestsellerSliderBlock/BestsellerSliderBlock.tsx






var TravelSliderBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8930).then(__webpack_require__.bind(__webpack_require__, 78930));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78930)
            ];
        }
    },
    ssr: false
});
var BestsellerSliderBlock = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var bestsellerState = (0,hooks/* useAppSelector */.C)(selectBestsellers);
    var ref = (0,react.useState)(false), domLoaded = ref[0], setDomLoaded = ref[1];
    (0,react.useEffect)(function() {
        setDomLoaded(true);
        if (!bestsellerState.isLoading) {
            dispatch((0,actions/* loadBestsellers */.u)({}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: domLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelSliderBanner, {
            title: t("bestseller"),
            travels: bestsellerState.travels
        })
    });
};
/* harmony default export */ var BestsellerSliderBlock_BestsellerSliderBlock = (BestsellerSliderBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/BestsellerSliderBlock/index.ts



/***/ }),

/***/ 67860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ContactBannerBlock_ContactBannerBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/ContactBannerBlock/ContactBannerBlock.module.scss
var ContactBannerBlock_module = __webpack_require__(94366);
var ContactBannerBlock_module_default = /*#__PURE__*/__webpack_require__.n(ContactBannerBlock_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(6498);
// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(38567);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/ContactBannerBlock/ContactBannerBlock.tsx






var ContactBannerBlock = function(param) {
    var block = param.block, cmsConfig = param.cmsConfig, _className = param.className, className = _className === void 0 ? "" : _className;
    var employee = block.employee;
    var _contactBlockSettings = cmsConfig.contactBlockSettings, slogan = _contactBlockSettings.slogan, title = _contactBlockSettings.title, text = _contactBlockSettings.text, phonePrefix = _contactBlockSettings.phonePrefix, phone = _contactBlockSettings.phone, phone2Prefix = _contactBlockSettings.phone2Prefix, phone2 = _contactBlockSettings.phone2, openingHours1 = _contactBlockSettings.openingHours1, openingHours2 = _contactBlockSettings.openingHours2, email = _contactBlockSettings.email;
    // Override with optional block settings
    phone = block.phone ? block.phone : phone;
    email = block.email ? block.email : email;
    var phoneLink = !phone ? phone : "tel:" + phone.replace("(0)", "").split(" ").join("");
    var phone2Link = !phone2 ? phone2 : "tel:" + phone2.replace("(0)", "").split(" ").join("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: "".concat((ContactBannerBlock_module_default()).root, " ").concat(className),
        "data-tr-view": "cms_block:contact_banner:view",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (ContactBannerBlock_module_default()).mainRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ContactBannerBlock_module_default()).imageWrap, " img-ratio-1-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: employee.image,
                            altDefault: employee.firstName + " " + employee.lastName + " | " + employee.jobTitle,
                            width: 420,
                            height: 420,
                            responsive: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        sm: {
                            span: 12,
                            offset: 0
                        },
                        lg: {
                            span: 8,
                            offset: 4
                        },
                        xl: {
                            span: 9,
                            offset: 3
                        },
                        className: (ContactBannerBlock_module_default()).title,
                        children: slogan
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        sm: {
                            span: 9,
                            offset: 3
                        },
                        lg: {
                            span: 8,
                            offset: 4
                        },
                        xl: {
                            span: 9,
                            offset: 3
                        },
                        className: (ContactBannerBlock_module_default()).contentCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 6,
                                    xl: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ContactBannerBlock_module_default()).subTitle,
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (ContactBannerBlock_module_default()).text,
                                            children: text
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ContactBannerBlock_module_default()).signature,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (ContactBannerBlock_module_default()).name,
                                                    children: [
                                                        employee.firstName,
                                                        " ",
                                                        employee.lastName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ContactBannerBlock_module_default()).jobTitle,
                                                    children: employee.jobTitle
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 6,
                                    xl: 5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (ContactBannerBlock_module_default()).contactBlock,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: "auto",
                                                    className: "".concat((ContactBannerBlock_module_default()).icon, " align-content-center"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                                                        src: "images/mandatory/icons/contact/phone.png",
                                                        width: 60,
                                                        height: 60,
                                                        alt: "phone icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((ContactBannerBlock_module_default()).link, " mb-1"),
                                                                children: [
                                                                    phonePrefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            phonePrefix,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: phoneLink,
                                                                        "data-tr-click": "cms_block:contact_phone:click",
                                                                        children: phone
                                                                    })
                                                                ]
                                                            }),
                                                            phone2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((ContactBannerBlock_module_default()).link, " mb-1"),
                                                                children: [
                                                                    phone2Prefix && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            phone2Prefix,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: phone2Link,
                                                                        "data-tr-click": "cms_block:contact_phone:click",
                                                                        children: phone2
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (ContactBannerBlock_module_default()).openingHours,
                                                                children: [
                                                                    openingHours1,
                                                                    openingHours2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            openingHours2
                                                                        ]
                                                                    }) : ""
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (ContactBannerBlock_module_default()).contactBlock,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xs: "auto",
                                                    className: (ContactBannerBlock_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                                                        src: "images/mandatory/icons/contact/mail.png",
                                                        width: 65,
                                                        height: 65,
                                                        alt: "mail icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ContactBannerBlock_module_default()).link,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:" + email,
                                                            "data-tr-click": "cms_block:contact_mail:click",
                                                            children: email
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ContactBannerBlock_ContactBannerBlock = (ContactBannerBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/ContactBannerBlock/index.ts



/***/ }),

/***/ 89570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NewsletterForm_NewsletterForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/newsletter/NewsletterForm/NewsletterForm.module.scss
var NewsletterForm_module = __webpack_require__(4386);
var NewsletterForm_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterForm_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(2736);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(88375);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./src/components/elements/icons/ArrowIcon/index.ts + 1 modules
var ArrowIcon = __webpack_require__(66707);
// EXTERNAL MODULE: ./src/app/context.ts
var context = __webpack_require__(27802);
// EXTERNAL MODULE: ./src/lib/ga/gtag.ts
var gtag = __webpack_require__(64426);
// EXTERNAL MODULE: ./src/integrations/tracking/useTracking.tsx + 4 modules
var useTracking = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/components/models/newsletter/NewsletterForm/NewsletterForm.tsx















// language=GraphQL
var REGISTER_NEWSLETTER_USER_MUTATION = "mutation RegisterNewsletterUser($input: RegisterNewsletterUserInput) {\n  registerNewsletterUser(input: $input) {\n    success\n    message\n  }\n}";
var schema = es.object().shape({
    salutation: es.string().required().oneOf([
        "m",
        "f"
    ], "Select salutation"),
    firstName: es.string().required(),
    lastName: es.string().required(),
    email: es.string().required()
});
var initialValues = {
    salutation: "",
    firstName: "",
    lastName: "",
    email: ""
};
var NewsletterForm = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var PrivacyPolicyPageUrl = (0,react.useContext)(context/* PrivacyPolicyPageUrlContext */.U9);
    var send = (0,useTracking/* useTracking */.r)().send;
    var ref = (0,react.useState)("initial"), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(false), inputTracked = ref1[0], setInputTracked = ref1[1];
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: schema,
        onSubmit: function() {
            send.genericEvent({
                category: "newsletter_signup",
                object: "signup_form",
                action: "submit",
                data: {}
            });
            graphQLClient/* default.request */.Z.request(REGISTER_NEWSLETTER_USER_MUTATION, {
                input: (0,_object_spread/* default */.Z)({
                    tenantId: "2"
                }, formik.values)
            }).then(function(response) {
                formik.setSubmitting(false);
                switch(response.registerNewsletterUser.success){
                    case true:
                        (0,gtag/* sendNewsletterSignupEvent */.B4)();
                        send.genericEvent({
                            category: "newsletter_signup",
                            object: "signup_form",
                            action: "success",
                            data: {}
                        });
                        setState("success");
                        break;
                    case false:
                        send.genericEvent({
                            category: "newsletter_signup",
                            object: "signup_form",
                            action: "error",
                            data: {}
                        });
                        setState("error");
                        break;
                }
            });
        }
    });
    (0,react.useEffect)(function() {
        if (!inputTracked && formik.values.email) {
            setInputTracked(true);
            send.genericEvent({
                category: "newsletter_signup",
                object: "signup_form",
                action: "input",
                data: {}
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formik.values.email
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    switch(state){
        case "success":
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    variant: "success",
                    className: "text-center mt-1 mb-3",
                    children: t("newsletter.registrationSuccess")
                })
            });
            break;
        case "error":
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                variant: "danger",
                className: "text-center mt-1 mb-3",
                children: t("newsletter.registrationError")
            });
            break;
        case "initial":
            content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                noValidate: true,
                onSubmit: formik.handleSubmit,
                "data-tr-view": "newsletter_signup:signup_form:view",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "form-group",
                            as: Col/* default */.Z,
                            controlId: "newsletterFormEmail",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    type: "text",
                                    name: "email",
                                    placeholder: "".concat(t("newsletter.email"), "*"),
                                    value: formik.values.email,
                                    onChange: formik.handleChange,
                                    isInvalid: formik.touched.email && !!formik.errors.email,
                                    className: (NewsletterForm_module_default()).input
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                    type: "invalid",
                                    children: [
                                        "* ",
                                        t("form.validation.required")
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "newsletterFormSalutation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control */.Z.Control, {
                                        as: "select",
                                        className: (NewsletterForm_module_default()).input + " " + (NewsletterForm_module_default()).select + " form-select",
                                        name: "salutation",
                                        placeholder: "".concat(t("newsletter.salutation"), "*"),
                                        value: formik.values.salutation,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.salutation && !!formik.errors.salutation,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                value: "",
                                                disabled: true,
                                                children: [
                                                    t("newsletter.salutation"),
                                                    " *"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "m",
                                                children: t("newsletter.mr")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "f",
                                                children: t("newsletter.mrs")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "newsletterFormFirstName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "firstName",
                                        placeholder: "".concat(t("newsletter.firstName"), "*"),
                                        value: formik.values.firstName,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.firstName && !!formik.errors.firstName,
                                        className: (NewsletterForm_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "newsletterFormLastName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "lastName",
                                        placeholder: "".concat(t("newsletter.lastName"), "*"),
                                        value: formik.values.lastName,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.lastName && !!formik.errors.lastName,
                                        className: (NewsletterForm_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "justify-content-end justify-content-md-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: "auto",
                                className: "mb-3 mb-lg-0 ".concat((NewsletterForm_module_default()).submitWrap),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                                fontsize: "9rem",
                                                className: (NewsletterForm_module_default()).arrow
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: "auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "submit",
                                                variant: "transparent",
                                                className: (NewsletterForm_module_default()).submitButton,
                                                disabled: formik.isSubmitting,
                                                children: "".concat(t("newsletter.register"))
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                md: 8,
                                className: "order-md-first d-none d-md-block mb-5 ".concat((NewsletterForm_module_default()).text),
                                children: [
                                    t("newsletter.promoText"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (NewsletterForm_module_default()).gtcInfo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                            i18nKey: "newsletter.gtcInfo",
                                            children: [
                                                "I accept the usage of cookies and the",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: PrivacyPolicyPageUrl,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "privacy policy"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NewsletterForm_module_default()).root + " an-wobble-horizontal-trigger",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                title: t("newsletter.newsletterRegistration"),
                                className: (NewsletterForm_module_default()).titleWrap
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            className: "my-3 d-md-none ".concat((NewsletterForm_module_default()).text),
                            children: [
                                t("newsletter.promoText"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (NewsletterForm_module_default()).gtcInfo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                        i18nKey: "newsletter.gtcInfo",
                                        children: [
                                            "I accept the usage of cookies and the",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: PrivacyPolicyPageUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "privacy policy"
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                content
            ]
        })
    });
};
/* harmony default export */ var NewsletterForm_NewsletterForm = (NewsletterForm);

;// CONCATENATED MODULE: ./src/components/models/newsletter/NewsletterForm/index.tsx



/***/ }),

/***/ 54592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DestinationsBlock_DestinationsBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/DestinationsBlock/DestinationsBlock.module.scss
var DestinationsBlock_module = __webpack_require__(23303);
var DestinationsBlock_module_default = /*#__PURE__*/__webpack_require__.n(DestinationsBlock_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(2736);
// EXTERNAL MODULE: ./src/components/elements/Accordion/index.ts + 1 modules
var Accordion = __webpack_require__(76144);
// EXTERNAL MODULE: ./src/components/cms/TextWithIcon/TextWithIcon.module.scss
var TextWithIcon_module = __webpack_require__(80893);
var TextWithIcon_module_default = /*#__PURE__*/__webpack_require__.n(TextWithIcon_module);
;// CONCATENATED MODULE: ./src/components/cms/TextWithIcon/TextWithIcon.tsx



var TextWithIcon = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _text = param.text, text = _text === void 0 ? "" : _text, Icon = param.Icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextWithIcon_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xs: "12",
                    xl: "auto",
                    className: (TextWithIcon_module_default()).iconWrap,
                    children: Icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    className: (TextWithIcon_module_default()).content,
                    children: [
                        title !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TextWithIcon_module_default()).cardTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: text
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TextWithIcon_TextWithIcon = (TextWithIcon);

;// CONCATENATED MODULE: ./src/components/cms/TextWithIcon/index.tsx


// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(38567);
;// CONCATENATED MODULE: ./src/components/models/destination/DestinationInformation/DestinationInformation.tsx





var DestinationInformation = function(param) {
    var destination = param.destination;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var groups = [
        {
            title: t("travel.countryInfo.entryRequirements"),
            text: destination.entryRequirements,
            icon: "/images/mandatory/icons/destination/entry-requirements.png"
        },
        {
            title: t("travel.countryInfo.timeShift"),
            text: destination.timeShift,
            icon: "/images/mandatory/icons/destination/time-shift.png"
        },
        {
            title: t("travel.countryInfo.medicalInformation"),
            text: destination.medicalInformation,
            icon: "/images/mandatory/icons/destination/medical.png"
        },
        {
            title: t("travel.countryInfo.climate"),
            text: destination.climate,
            icon: "/images/mandatory/icons/destination/climate.png"
        },
        {
            title: t("travel.countryInfo.language"),
            text: destination.language,
            icon: "/images/mandatory/icons/destination/language.png"
        },
        {
            title: t("travel.countryInfo.currency"),
            text: destination.currency,
            icon: "/images/mandatory/icons/destination/currency.png"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        "data-tr-view": "travel_page:destination_accordion_item_content:view",
        children: groups.map(function(group, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithIcon_TextWithIcon, {
                    title: group.title,
                    text: group.text,
                    Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
                        src: group.icon,
                        width: 110
                    })
                })
            }, index);
        })
    });
};
/* harmony default export */ var DestinationInformation_DestinationInformation = (DestinationInformation);

;// CONCATENATED MODULE: ./src/components/models/destination/DestinationInformation/index.ts


;// CONCATENATED MODULE: ./src/components/models/destination/DestinationAccordion/DestinationAccordion.tsx



var DestinationAccordion = function(param) {
    var destinations = param.destinations, collapsed = param.collapsed;
    var accordionItems = destinations.map(function(destination) {
        return {
            title: destination.name,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationInformation_DestinationInformation, {
                destination: destination
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
            items: accordionItems,
            collapsed: collapsed,
            trackingCategoryAndObject: "travel_page:destination_accordion_item"
        })
    });
};
/* harmony default export */ var DestinationAccordion_DestinationAccordion = (DestinationAccordion);

;// CONCATENATED MODULE: ./src/components/models/destination/DestinationAccordion/index.ts


;// CONCATENATED MODULE: ./src/components/models/travel/DestinationsBlock/DestinationsBlock.tsx






var DestinationsBlock = function(param) {
    var destinations = param.destinations, collapsed = param.collapsed;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    if (destinations.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: (DestinationsBlock_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "destinations",
                        className: "anchor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                    title: t("travel.countryInformation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationAccordion_DestinationAccordion, {
                                    destinations: destinations,
                                    collapsed: collapsed
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: (DestinationsBlock_module_default()).root
    });
};
/* harmony default export */ var DestinationsBlock_DestinationsBlock = (DestinationsBlock);

;// CONCATENATED MODULE: ./src/components/models/travel/DestinationsBlock/index.tsx



/***/ }),

/***/ 80893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIcon_root__Mt58A","content":"TextWithIcon_content__be1SB","cardTitle":"TextWithIcon_cardTitle__OxpEY","iconWrap":"TextWithIcon_iconWrap__3EZER"};

/***/ }),

/***/ 94366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactBannerBlock_root__bulBs","mainRow":"ContactBannerBlock_mainRow__Kf1e_","imageWrap":"ContactBannerBlock_imageWrap__de8A4","title":"ContactBannerBlock_title__bWa7V","contentCol":"ContactBannerBlock_contentCol__TjkZX","subTitle":"ContactBannerBlock_subTitle__e8lhv","signature":"ContactBannerBlock_signature__pLCSL","name":"ContactBannerBlock_name__0TFfJ","jobTitle":"ContactBannerBlock_jobTitle___CDd3","contactBlock":"ContactBannerBlock_contactBlock__ODoR6","icon":"ContactBannerBlock_icon__uMn2E","link":"ContactBannerBlock_link__RJsXY","openingHours":"ContactBannerBlock_openingHours__K2Dno"};

/***/ }),

/***/ 4386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterForm_root__KcW0z","titleWrap":"NewsletterForm_titleWrap__vZvKC","input":"NewsletterForm_input__Xe5hl","select":"NewsletterForm_select__Ate7x","submitWrap":"NewsletterForm_submitWrap__jaLRw","arrow":"NewsletterForm_arrow__U9P8j","submitButton":"NewsletterForm_submitButton__NEmmN","text":"NewsletterForm_text__WyiX3","gtcInfo":"NewsletterForm_gtcInfo__y6h_g"};

/***/ }),

/***/ 23303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"DestinationsBlock_root__mfHSz"};

/***/ })

}]);